import type { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SessionContextProvider } from "@/integrations/supabase/SessionContextProvider";
import GlobalAdsenseScriptManager from "@/components/ads/GlobalAdsenseScriptManager";
import ScrollToTopOnRouteChange from "@/components/feature/ScrollToTopOnRouteChange";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <SessionContextProvider>{children}</SessionContextProvider>
    </I18nextProvider>
  );
}

export function AppContent() {
  return (
    <>
      <ScrollToTopOnRouteChange />
      <GlobalAdsenseScriptManager />
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <AppProviders>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppContent />
      </BrowserRouter>
    </AppProviders>
  );
}

export default App;
